export const ADDPRODUCTTOCART = 'cart/addproduct';
export const DELETEPRODUCTTOCART = 'cart/deleteproduct';
